<template>
  <div class="GisButton">
    <div class="reset" @click="resetFn" title="复位"></div>
    <div
      class="rotate"
      title="旋转"
      @click="rotateFn"
      :class="cameraRotate ? 'rotate_ac' : ''"
    ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CameraList from '../../utils/configs/cameraList'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(['cameraRotate', 'topic', 'subTopic', 'cameraInfo']),
  },
  methods: {
    resetFn(item) {
      let jsonData = CameraList[this.cameraInfo]
      window.layerConfig.recoverDefaultState()
      window.appInstance.uniCall('setCamera', jsonData)
    },
    rotateFn() {
      this.$store.commit('setCameraRotate', !this.cameraRotate)
    },
  },
  mounted() {
    // window.appInstance.uniCall('addEventListener', {
    //   eventName: 'onSceneClick',
    //   callback: (res) => {
    //     if (this.cameraRotate) {
    //       this.$store.commit('setCameraRotate', false)
    //     }
    //   },
    // })
  },
}
</script>

<style lang="less" scoped>
.GisButton {
  display: flex;
  pointer-events: all;
  .reset {
    width: 60px;
    height: 60px;
    margin: 0px 20px;
    background: url(../../assets/img/commonComponents/positionme.png) no-repeat
      center center;
    background-size: cover;
  }
  .rotate {
    width: 60px;
    height: 60px;
    background: url(../../assets/img/commonComponents/resovet.png) no-repeat
      center center;
    background-size: cover;
  }
  .rotate_ac {
    background: url(../../assets/img/commonComponents/resovet.png)
      no-repeat center center;
    background-size: cover;
  }
}
</style>
